import { useState, useRef, useContext, useCallback, useEffect } from "react";
import { Button } from "primereact/button";
import "./index.css";
import "../../utils/main.css";
import { InputNumber } from "primereact/inputnumber";
import ModalConfirm from "../../components/ui/modal/ModalConfirm";
import { InitDataForTablesContext } from "../../context/InitDataForTables";
import DropdownFilter from "../../components/dropdown/DropdownFilter";
import ModalSignature from "../../components/ui/modal/ModalSignature";
import * as api from "../../utils/Api";
import { InitDataContext } from "../../context/InitDataContext";
import {
  FILTER_ITEMS_BY_DOC_TYPE,
  parseNumberCommaFormatForOperations,
  VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT,
} from "../../utils/Constants";
import { Toast } from "primereact/toast";
import { showMsg } from "../../utils/Constants.tsx";
import { Dialog } from "primereact/dialog";
import UploadFile from "../../components/widgets/UploadFile.tsx";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";
import Joyride, { CallBackProps, StoreHelpers } from "react-joyride";
import { InputTextarea } from "primereact/inputtextarea";

/*** JOYRIDE TUTORIAL ONBOARD ****/
const steps = [
  {
    target: "#rightBox",
    content:
      "Este es el nuevo espacio para crear solicitudes de ordenes de compra, se compone de datos de cabecera y detalles.",
    disableBeacon: true,
  },
  {
    target: ".os-topbox",
    content:
      "Aquí seleccionas los datos de cabecera que aplicarán para todos los detalles",
    disableBeacon: true,
  },
  {
    target: "#os_tipo_solicitud",
    content:
      "Aquí seleccionas si la solicitud se trata del tipo stock, servicios u otro.",
    disableBeacon: true,
  },
  {
    target: "#os_mes_gasto",
    content:
      "Aquí seleccionas el mes de gasto que corresponde al mes sobre el cual se desea tomar el presupuesto asignado.",
    disableBeacon: true,
  },
  {
    target: "#os_estado_operacional",
    content:
      "Este campo es una etiqueta de apoyo operacional a la gestión de esta solicitud y posterior orden.",
    disableBeacon: true,
  },
  {
    target: "#os_tipo_moneda",
    content:
      "Aquí seleccionas el tipo de moneda que se utilizará en la solicitud, recuerda todos los detalles compartirán esta moneda.",
    disableBeacon: true,
  },
  {
    target: "#os_detail_row_0",
    content:
      "En esta sección creas el primer detalle de la solicitud, donde seleccionas todos los atributos necesarios para adquirir el producto/servicio deseado. Todos los campos son obligatorios y el precio total se rellena automáticamente.",
    disableBeacon: true,
  },
  {
    target: "#os_detalles_0",
    content:
      "Esta sección sustituye las antiguas 3 glosas y es obligatorio dar detalles en esta sección.",
    disableBeacon: true,
  },
  {
    target: "#btn_create_firma",
    content:
      "Pero primero, debes crear una firma digital aquí, este paso es importante y se realiza una sola vez.",
    disableBeacon: true,
  },
  {
    target: "#btn-new-row_0",
    content:
      "Aquí puedes agregar un nuevo producto/servicio a la misma solicitud, puedes incluso escoger distintos proveedores, centros de costo. Asegúrate de completar todos los campos requeridos.",
    disableBeacon: true,
  },
  {
    target: "#btn_save_solicitud",
    content:
      "Una  vez completados todos los campos que deseas para la solicitud, haces click aquí y das tu confirmación.",
    disableBeacon: true,
  },
  {
    target: "#btn_save_solicitud",
    content:
      "Al generar la solicitud, se abrirá una ventana de subida de documento opcional a la solicitud, por ejemplo una ficha de producto.",
    disableBeacon: true,
  },
  {
    target: ".menu-bar-sub-option-link",
    content:
      'Aquí en el menú "Seguimiento y consulta" podrás editar las solicitudes que tu hayas creado y podrás ver los estados de aprobación tanto de tus solicitudes como las de otros usuarios pertenecientes a tu centro de costo.',
    disableBeacon: true,
  },
  {
    target: "#btn_save_solicitud",
    content: "¡Eso es todo, así de simple!",
    disableBeacon: true,
  },
];

type Item = {
  id: number;
  nombre: string;
};

type Detalle = {
  cantidad: any;
  item: any;
  centrocosto: any;
  proveedor: any;
  preciorefunitario: any;
  preciorefunitariototal: any;
  detalles: string;
};

type Solicitud = {
  tiposolicitud: number;
  mesgasto: number;
  estadooperacional: number;
  tipomoneda: number;
  observaciones: string;
  detalles: Detalle[];
};

function NewSolicitudCompra() {
  const {
    itemsAdquisicion,
    centrosCosto,
    proveedores,
    tipoSolicitudes,
    meses,
    estadosOperacionales,
    tiposMoneda,
    estadosSolicitud,
    tiposItemsAdquisicion,
    aprobadores,
    aprobadoresFull,
  } = useContext(InitDataForTablesContext);

  const navigate = useNavigate();
  const [itemsFiltered, setItemsFiltered] = useState(itemsAdquisicion);

  useEffect(() => {
    if (itemsFiltered.length == 0) {
      setItemsFiltered(
        FILTER_ITEMS_BY_DOC_TYPE(itemsAdquisicion, 0, tiposItemsAdquisicion),
      );
    }
  }, [itemsAdquisicion]);

  const [goHome, setGoHome] = useState(false);
  useEffect(() => {
    if (goHome) {
      navigate("/", { replace: true });
    }
  }, [goHome]);

  const { initData, isTutorialActive } = useContext(InitDataContext);
  /***** HEADER ******/
  const [selectedTipoSolicitudId, setSelectedTipoSolicitudId] =
    useState<number>(0);
  const [selectedTipoSolicitud, setSelectedTipoSolicitud] =
    useState<string>("Seleccione...");
  const [selectedMesGastoId, setSelectedMesGastoId] = useState<number>(0);
  const [selectedMesGasto, setSelectedMesGasto] =
    useState<string>("Seleccione...");
  const [selectedEstadoOpId, setSelectedEstadoOpId] = useState<number>(0);
  const [selectedEstadoOp, setSelectedEStadoOp] =
    useState<string>("Seleccione...");
  const [selectedTipoMonedaId, setSelectedTipoMonedaId] = useState<number>(0);
  const [selectedTipoMoneda, setSelectedTipoMoneda] =
    useState<string>("Seleccione...");
  /********************************************* BODY *******************************************/
  const [quantity, setQuantity] = useState<number[]>([0]);
  const [selectedItemId, setSelectedItemId] = useState<number[]>([0]);
  const [selectedItem, setSelectedItem] = useState<string[]>([]);
  const [selectedCentroCostoId, setSelectedCentroCostoId] = useState<number[]>([
    0,
  ]);
  const [selectedCentroCosto, setSelectedCentroCosto] = useState<string[]>([]);
  const [selectedProveedorId, setSelectedProveedorId] = useState<number[]>([0]);
  const [selectedProveedor, setSelectedProveedor] = useState<string[]>([]);
  const [precioRefUnitario, setPrecioRefUnitario] = useState<number[]>([0]);
  const [precioRefUnitarioTotal, setPrecioRefUnitarioTotal] = useState<
    number[]
  >([0]);
  const [selectedAprobador, setSelectedAprobador] = useState<string[]>([]);
  const [selectedAprobadorId, setSelectedAprobadorId] = useState<number[]>([0]);
  const [detalles, setDetalles] = useState<string[]>([]);
  const detallesRef = useRef<{ [key: number]: string }>({});
  const [divNuevoDetalleCounter, setDivNuevoDetalleCounter] = useState(0);
  const [divChildrens, setDivChildrens] = useState<
    { cantidad: HTMLElement | null }[]
  >([]);
  const [showAddLineButton, setShowAddLineButton] = useState<
    (string | undefined)[]
  >([]);
  const [jsonDataSolicitud, setJsonDataSolicitud] = useState<Solicitud>();
  const ref = useRef<any>(null);
  const areaRef = useRef<HTMLTextAreaElement>(null);
  const [value, setValue] = useState("Seleccione...");

  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [showModalFirma, setShowModalFirma] = useState(false);
  const lastPriceItemSelected = useRef<any[]>([]);
  const toast = useRef(null);
  const [showDialogUploadFile, setShowDialogUploadFile] = useState(false);
  const [docId, setDocId] = useState(0);
  const today = new Date();
  const ano = today.getFullYear();
  const mes = (today.getMonth() + 1).toString().padStart(2, "0");
  const [needFetchingSoc, setNeedFetchingSoc] = useState(false);
  /*** JOYRIDE TUTORIAL */
  const [isOnboardOn, setIsOnBoardOn] = useState(isTutorialActive);
  let helpers: StoreHelpers | null = null;
  const [observaciones, setObservaciones] = useState("");

  // Refs for auto-scrolling
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = useCallback(() => {
    requestAnimationFrame(() => {
      setTimeout(() => {
        if (scrollEndRef.current) {
          scrollEndRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        } else if (containerRef.current) {
          containerRef.current.scrollTo({
            top: containerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 50);
    });
  }, []);

  // Scroll to bottom when a new line is added
  useEffect(() => {
    if (divNuevoDetalleCounter > 0) {
      scrollToBottom();
    }
  }, [divNuevoDetalleCounter, scrollToBottom]);

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, type } = data;
    const finishedStatuses: string[] = ["STATUS.FINISHED", "STATUS.SKIPPED"];

    if (finishedStatuses.includes(status)) {
      setIsOnBoardOn(false);
      localStorage.setItem("isTutorialActive", "false");
    }

    if (
      data.action === "reset" ||
      data.action === "skip" ||
      data.action === "close"
    ) {
      setIsOnBoardOn(false);
      localStorage.setItem("isTutorialActive", "false");
    }
  };

  const getHelpers = (helpers: StoreHelpers) => {
    helpers = helpers;
  };

  const removeAddedLine = (idx: number) =>
    document.getElementById(`os_detail_row_${idx}`)?.remove();

  const getPptoDisponibleValida = async (
    idCentroCosto: number,
    idItem: number,
    numeroLinea: number,
  ) => {
    const responseGetPptoDisponible =
      await api.GET_PPTO_DISPONIBLE_CC.getPptoCentroCosto(
        initData.id,
        idCentroCosto,
        idItem,
      );
    if (responseGetPptoDisponible !== null) {
      console.log(JSON.stringify(responseGetPptoDisponible));
    } else {
      return "error";
    }

    const responseGetPptoSolicitadoCentro =
      await api.GET_PPTO_SOLICITADO_CC.getPptoDisponibleCentroCosto(
        initData.id,
        idCentroCosto,
        selectedMesGastoId,
        idItem,
      );

    if (responseGetPptoSolicitadoCentro !== null) {
      let sumPresupuestoDisponibleCentro = 0;
      for (var x = 1; x < selectedMesGastoId; x++) {
        switch (x) {
          case 1:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.enero;
            break;
          case 2:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.febrero;
            break;
          case 3:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.marzo;
            break;
          case 4:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.abril;
            break;
          case 5:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.mayo;
            break;
          case 6:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.junio;
            break;
          case 7:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.julio;
            break;
          case 8:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.agosto;
            break;
          case 9:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.septiembre;
            break;
          case 10:
            sumPresupuestoDisponibleCentro += responseGetPptoDisponible.octubre;
            break;
          case 11:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.noviembre;
            break;
          case 12:
            sumPresupuestoDisponibleCentro +=
              responseGetPptoDisponible.diciembre;
            break;
          default:
        }
      }

      let totalValueLine =
        (
          document.getElementById(`os_precio_unitario_total_${numeroLinea}`)
            ?.children[0] as HTMLInputElement
        )?.value ?? "0";

      let errorElement = document.getElementById(
        `ppto_error_${numeroLinea}`,
      ) as HTMLInputElement;

      let presupuestoSolicitadoTotalCc =
        responseGetPptoSolicitadoCentro.total +
        parseNumberCommaFormatForOperations(totalValueLine);

      console.log(
        "CHECK sumPresupuestoDisponibleCentro: ",
        sumPresupuestoDisponibleCentro,
      );
      console.log(
        "CHECK presupuestoSolicitadoTotalCc: ",
        presupuestoSolicitadoTotalCc,
      );

      if (sumPresupuestoDisponibleCentro < presupuestoSolicitadoTotalCc) {
        errorElement.innerText = "Sobrepasa el presupuesto disponible";
        return "#ff6767";
      }

      if (
        sumPresupuestoDisponibleCentro > presupuestoSolicitadoTotalCc &&
        presupuestoSolicitadoTotalCc >
          (sumPresupuestoDisponibleCentro * 90) / 100
      ) {
        errorElement.style.color = "#cdca6d";
        errorElement.innerText = "Has superado el 90% del presupuesto";
        return "yellow";
      } else {
        errorElement.style.color = "#000000";
        errorElement.innerText = "Presupuesto disponible";
        return "#FFFFFF";
      }
    } else {
      return "error";
    }
  };

  const handleQuantityChange = (value: number, index: number) => {
    const totalPrecioUni = value * precioRefUnitario[index];
    setPrecioRefUnitarioTotal((prev) => {
      const updated = [...prev];
      updated[index] = totalPrecioUni;
      return updated;
    });
    scrollToBottom();
  };

  const handlePrecioUnitarioChange = (value: number, index: number) => {
    let totalPrecioUni = 0;
    if (quantity[index]) {
      totalPrecioUni = quantity[index] * value;
    }
    setPrecioRefUnitarioTotal((prev) => {
      const updated = [...prev];
      updated[index] = totalPrecioUni;
      return updated;
    });
  };

  const handleKeyDownTextArea = (
    e: React.KeyboardEvent<HTMLTextAreaElement>,
    index: number,
  ) => {
    if (e.key === "Escape") {
      setDetalles((prev) => {
        const updated = [...prev];
        updated[index] = "";
        return updated;
      });
      e.currentTarget.blur();
      e.stopPropagation();
    }
  };

  const handleUpdateTextArea = (e: any, index: number) => {
    if (detallesRef.current[index] == e.target.innerHTML) {
    } else {
      detallesRef.current[index] = e.target.innerHTML;
    }
  };

  const handleUpdateItemsFromChild = useCallback(
    (option: any, idRow: number) => {
      console.log("SelectedTipoSolicitudId: ", selectedTipoSolicitudId);
      if (selectedTipoSolicitudId === 0) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe seleccionar el tipo de solicitud primero",
        );
        return;
      }

      setSelectedItem((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.nombre ?? "";

        return updated;
      });

      setSelectedItemId((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.id ?? 0;
        return updated;
      });

      fetchLastPriceItemSelected(option.id, idRow);
      scrollToBottom();
    },
    [
      setSelectedItem,
      setSelectedItemId,
      selectedTipoSolicitudId,
      scrollToBottom,
    ],
  );

  const handleUpdateCentrosFromChild = useCallback(
    (option: any, idRow: number) => {
      setSelectedCentroCosto((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.nombre ?? "";

        return updated;
      });

      setSelectedCentroCostoId((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.id ?? 0;
        return updated;
      });
      scrollToBottom();
    },
    [setSelectedCentroCosto, setSelectedCentroCostoId, scrollToBottom],
  );

  const handleUpdateProveedoresFromChild = useCallback(
    (option: any, idRow: number) => {
      setSelectedProveedor((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.nombre ?? "";

        return updated;
      });

      setSelectedProveedorId((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.id ?? 0;
        return updated;
      });
      scrollToBottom();
    },
    [setSelectedProveedor, setSelectedProveedorId, scrollToBottom],
  );

  const handleUpdateAprobadoresFromChild = useCallback(
    (option: any, idRow: number) => {
      setSelectedAprobador((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.nombre ?? "";

        return updated;
      });

      setSelectedAprobadorId((prev: any) => {
        const updated = [...prev];
        updated[idRow] = option.id ?? 0;
        return updated;
      });
      scrollToBottom();
    },
    [setSelectedAprobador, setSelectedAprobadorId, scrollToBottom],
  );

  const handleUpdateTipoSolFromChild = (option: any, idRow: number) => {
    setSelectedTipoSolicitud(option.nombre ?? "");
    setSelectedTipoSolicitudId(option.id ?? 0);

    setItemsFiltered(
      FILTER_ITEMS_BY_DOC_TYPE(
        itemsAdquisicion,
        option.id,
        tiposItemsAdquisicion,
      ),
    );
  };

  const handleUpdateMesGastoFromChild = useCallback(
    (option: any, idRow: number) => {
      setSelectedMesGasto(option.nombre ?? "");
      setSelectedMesGastoId(option.id ?? 0);
    },
    [setSelectedMesGasto, setSelectedMesGastoId],
  );

  const handleUpdateEstadoOpFromChild = useCallback(
    (option: any, idRow: number) => {
      if (option.id === 3) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "La asignación directa será validada o cuestionada por el Gerente General, por favor ingresa tu justificación.",
        );
      }
      setSelectedEStadoOp(option.nombre ?? "");
      setSelectedEstadoOpId(option.id ?? 0);
    },
    [setSelectedEStadoOp, setSelectedEstadoOpId],
  );

  const handleUpdateTipoMonedaFromChild = useCallback(
    (option: any, idRow: number) => {
      setSelectedTipoMoneda(option.nombre ?? "");
      setSelectedTipoMonedaId(option.id ?? 0);
    },
    [setSelectedTipoMoneda, setSelectedTipoMonedaId],
  );

  const fetchLastPriceItemSelected = async (
    idItemSelected: number,
    idRow: number,
  ) => {
    try {
      const responseGetLastPriceItem =
        await api.GET_LAST_PRICE_ITEM_SELECTED.getLastPriceItemSelected(
          idItemSelected,
        );
      if (responseGetLastPriceItem !== null) {
        console.log(responseGetLastPriceItem);
        lastPriceItemSelected.current[idRow] =
          responseGetLastPriceItem.ultimo_precio_unitario_neto;

        setPrecioRefUnitario((prev) => {
          const updated = [...prev];
          updated[idRow] = responseGetLastPriceItem.ultimo_precio_unitario_neto;
          return updated;
        });

        const cantidadElement = document.getElementById(`cantidad_${idRow}`)
          ?.childNodes[0] as HTMLFormElement;

        let cleanValue = cantidadElement.value
          .replace(/\./g, "")
          .replace(",", ".");

        let quantityRow = parseFloat(cleanValue);

        setPrecioRefUnitarioTotal((prev) => {
          const updated = [...prev];
          updated[idRow] =
            responseGetLastPriceItem.ultimo_precio_unitario_neto * quantityRow;
          return updated;
        });
      }

      let quantityAvailableElement = document.getElementById(
        `quantity_available_${idRow}`,
      );

      if (quantityAvailableElement) {
        quantityAvailableElement.innerHTML =
          responseGetLastPriceItem.cantidad_existencia;
      }
    } catch (error) {
      setPrecioRefUnitario((prev) => {
        const updated = [...prev];
        updated[idRow] = 0;
        return updated;
      });

      setPrecioRefUnitarioTotal((prev) => {
        const updated = [...prev];
        updated[idRow] = 0;
        return updated;
      });
      console.error("Error fetching last price item:", error);
    }
  };

  const [loading, setLoading] = useState(false);
  const loadLazyTimeout = useRef<number>();
  const items = useRef(Array.from({ length: 40000 }));
  const itemsLazy = Array.from({ length: 100000 }).map((_, i) => ({
    label: `Item #${i}`,
    value: i,
  }));

  const textAreaRender = (props: any) => (
    <div
      contentEditable="true"
      suppressContentEditableWarning={true}
      style={{
        border: 1,
        borderStyle: "solid",
        width: "280px",
        height: "140px",
        padding: "20px",
      }}
      id={`os_detalles_${props.number}`}
      onInput={(e) => handleUpdateTextArea(e, props.number)}
      onError={() => alert("XSS detectado")}
      dangerouslySetInnerHTML={createMarkup(props)}
    ></div>
  );

  const sanitizedHtml = (props: any) => {
    const rawHtml = detallesRef.current[props.number] ?? "";
    return DOMPurify.sanitize(rawHtml);
  };

  const createMarkup = (props: any) => {
    try {
      return { __html: sanitizedHtml(props) };
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const RowDivDetalleSolicitud = (props: any) => (
    <div>
      <div id={`os_detail_row_${props.number}`} className="os-topbox">
        <label style={{ marginRight: "20px" }}>
          Cantidad
          <InputNumber
            ref={ref}
            id={`cantidad_${props.number}`}
            placeholder="Cantidad"
            minFractionDigits={4}
            locale="de-DE"
            min={0}
            value={quantity[props.number]}
            onValueChange={(e) => {
              setQuantity((prev) => {
                const updated = [...prev];
                updated[props.number] = e.value ?? 0;
                return updated;
              });

              handleQuantityChange(e.value ?? 0, props.number);
              if (
                selectedCentroCostoId[props.number] !== undefined &&
                selectedItemId[props.number] !== undefined
              ) {
                getPptoDisponibleValida(
                  selectedCentroCostoId[props.number],
                  selectedItemId[props.number],
                  props.number,
                ).then((validaMontoVsPpto) => {
                  const element = document.getElementById(
                    `os_precio_unitario_total_${props.number}`,
                  );
                  if (element) {
                    element.style.backgroundColor = validaMontoVsPpto;
                  }
                });
              }
            }}
            showButtons
            buttonLayout="horizontal"
            step={1}
            decrementButtonClassName="p-button-danger"
            incrementButtonClassName="p-button-success"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
          />
          <span
            id={`quantity_available_${props.number}`}
            style={{ fontSize: "10px", color: "black" }}
          ></span>
        </label>

        <DropdownFilter
          id={`os_item_${props.number}`}
          labelHead="Producto/Servicio"
          initialData={itemsFiltered}
          data={selectedItem[props.number] ?? ""}
          dataId={selectedItemId[props.number] ?? 0}
          handleUpdateItems={handleUpdateItemsFromChild}
          idRow={props.number}
          virtualScrollerOptions={{ itemSize: 100 }}
        />

        <DropdownFilter
          id={`os_centro_costo_${props.number}`}
          labelHead="Centros de Costo"
          initialData={centrosCosto}
          data={selectedCentroCosto[props.number] ?? ""}
          dataId={selectedCentroCostoId[props.number] ?? 0}
          handleUpdateItems={handleUpdateCentrosFromChild}
          idRow={props.number}
          virtualScrollerOptions={{ itemSize: 100 }}
        />

        <DropdownFilter
          id={`os_proveedor_${props.number}`}
          labelHead="Proveedor"
          initialData={proveedores}
          data={selectedProveedor[props.number] ?? ""}
          dataId={selectedProveedorId[props.number] ?? 0}
          handleUpdateItems={handleUpdateProveedoresFromChild}
          idRow={props.number}
          virtualScrollerOptions={{ itemSize: 100 }}
        />

        <label>
          Precio Ref. Unitario
          <InputNumber
            ref={ref}
            id={`os_precio_unitario_${props.number}`}
            value={precioRefUnitario[props.number]}
            placeholder="Ingresa el precio del item..."
            minFractionDigits={4}
            locale="de-DE"
            min={0}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            onValueChange={(e) => {
              const value = e.target.value;
              setPrecioRefUnitario((prev) => {
                const updated = [...prev];
                updated[props.number] = value ?? 0;
                return updated;
              });

              handlePrecioUnitarioChange(value ?? 0, props.number);
              if (
                selectedCentroCostoId[props.number] !== undefined &&
                selectedItemId[props.number] !== undefined
              ) {
                getPptoDisponibleValida(
                  selectedCentroCostoId[props.number],
                  selectedItemId[props.number],
                  props.number,
                ).then((validaMontoVsPpto) => {
                  const element = document.getElementById(
                    `os_precio_unitario_total_${props.number}`,
                  );
                  if (element) {
                    element.style.backgroundColor = validaMontoVsPpto;
                  }
                });
              }
            }}
          />
        </label>
      </div>

      <div
        className="card flex justify-content-center"
        style={{ display: "flex", justifyContent: "center", width: "100%" }}
        onPaste={(e) => {
          e.preventDefault();
          showMsg(
            toast,
            "warn",
            "Advertencia",
            "El pegado de texto está deshabilitado para este campo.",
          );
        }}
      >
        <label
          htmlFor="name"
          className="labelEditRow"
          style={{ display: "table-caption" }}
        >
          Detalles Adicionales
          {textAreaRender(props)}
        </label>

        <div style={{ marginLeft: "20px" }}>
          <DropdownFilter
            id={`os_usuarios_aprueba_${props.number}`}
            labelHead="Aprobador"
            initialData={aprobadores}
            data={selectedAprobador[props.number] ?? ""}
            dataId={selectedAprobadorId[props.number] ?? 0}
            handleUpdateItems={handleUpdateAprobadoresFromChild}
            idRow={props.number}
            virtualScrollerOptions={{ itemSize: 100 }}
          />
        </div>

        <label style={{ marginLeft: "20px" }}>
          Precio Ref. Total
          <InputNumber
            ref={ref}
            id={`os_precio_unitario_total_${props.number}`}
            value={precioRefUnitarioTotal[props.number]}
            minFractionDigits={4}
            locale="de-DE"
            min={0}
            disabled
          />
          <span
            id={`ppto_error_${props.number}`}
            style={{ fontSize: "10px", color: "red", display: "block" }}
          ></span>
        </label>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="custom-buttonform"
          id={`btn-new-row_${props.number}`}
          style={{
            display: `${showAddLineButton[props.number]}`,
            margin: "20px",
          }}
          onClick={(e) => onAddRowDetalle(e)}
        >
          NUEVA LÍNEA
        </button>

        {divNuevoDetalleCounter > 0 ? (
          <button
            className="custom-buttonform"
            id={`btn-new-row_${props.number}`}
            style={{
              margin: "20px",
              backgroundColor: "red",
              color: "white",
              fontWeight: "bold",
              display: `${showAddLineButton[props.number]}`,
            }}
            onClick={(e) => onDeleteDetalle(e)}
          >
            BORRAR LÍNEA
          </button>
        ) : null}
      </div>
      <hr id="separator" style={{ width: "100%" }} />
    </div>
  );

  const childrenDetalle = [];

  for (var i = 0; i < divNuevoDetalleCounter; i += 1) {
    childrenDetalle.push(<RowDivDetalleSolicitud key={i + 1} number={i + 1} />);
  }

  const onAddRowDetalle = (e: any) => {
    const element = e.target.id;
    const indexElement = element.split("_")[1];

    const cantidadElement = document.getElementById(`cantidad_${indexElement}`)
      ?.childNodes[0] as HTMLFormElement;
    const item = (
      document.getElementById(`os_item_${indexElement}`) as HTMLFormElement
    ).value;
    const centroCosto = (
      document.getElementById(
        `os_centro_costo_${indexElement}`,
      ) as HTMLFormElement
    ).value;

    const proveedor = (
      document.getElementById(`os_proveedor_${indexElement}`) as HTMLFormElement
    ).value;

    const precioUnitario = document.getElementById(
      `os_precio_unitario_${indexElement}`,
    )?.childNodes[0] as HTMLFormElement;

    const precioUnitarioTotal = document.getElementById(
      `os_precio_unitario_total_${indexElement}`,
    )?.childNodes[0] as HTMLFormElement;

    const detalles = document.getElementById(
      `os_detalles_${indexElement}`,
    )?.innerHTML;

    if (
      parseInt(cantidadElement.value) > 0 &&
      item !== "" &&
      centroCosto !== "" &&
      proveedor !== "" &&
      parseInt(precioUnitario.value) >= 0 &&
      parseInt(precioUnitarioTotal.value) >= 0 &&
      (detalles?.length ?? 0) > 0
    ) {
      setShowAddLineButton((prev) => {
        const updated = [...prev];
        updated[indexElement] = "none";
        return updated;
      });

      setDivNuevoDetalleCounter(divNuevoDetalleCounter + 1);
    } else {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe completar todos los campos de la fila anterior",
      );
    }
  };

  const onDeleteDetalle = (e: any) => {
    const element = e.target.id;
    const indexElement = element.split("_")[1];
    removeAddedLine(indexElement);
    if (divNuevoDetalleCounter > 0) {
      setDivNuevoDetalleCounter(divNuevoDetalleCounter - 1);

      setShowAddLineButton((prev) => {
        const updated = [...prev];
        updated[indexElement - 1] = "block";
        return updated;
      });
    }
  };

  const saveSolicitud = () => {
    let lengthRowsDetalle = childrenDetalle.length;

    let jsonObj: Solicitud = {
      tiposolicitud: selectedTipoSolicitudId,
      mesgasto: selectedMesGastoId,
      estadooperacional: selectedEstadoOpId,
      tipomoneda: selectedTipoMonedaId,
      observaciones: observaciones,
      detalles: [],
    };

    if (
      selectedTipoSolicitudId === 0 ||
      selectedMesGastoId === 0 ||
      selectedEstadoOpId === 0 ||
      selectedTipoMonedaId === 0
    ) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Deben ser seleccionados todos los datos de cabecera de la solicitud",
      );
    } else if (selectedEstadoOpId === 3 && observaciones.trim() === "") {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe ingresar la justificación para ingresar una asignación directa",
      );
    } else if (selectedEstadoOpId === 3 && observaciones.length < 4) {
      showMsg(
        toast,
        "warn",
        "Advertencia",
        "Debe ingresar más detalles en la justificación para ingresar una asignación directa",
      );
    } else {
      for (var i = 0; i < lengthRowsDetalle + 1; i++) {
        const cantidadElement = document.getElementById(`cantidad_${i}`)
          ?.childNodes[0] as HTMLFormElement;

        const precioUnitario = document.getElementById(
          `os_precio_unitario_${i}`,
        )?.childNodes[0] as HTMLFormElement;

        const precioUnitarioTotal = document.getElementById(
          `os_precio_unitario_total_${i}`,
        )?.childNodes[0] as HTMLFormElement;

        const detalles = document.getElementById(
          `os_detalles_${i}`,
        ) as HTMLFormElement;

        let aprobadorUsuarioId = aprobadoresFull.find(
          (aprob) => aprob.id === selectedAprobadorId[i],
        );

        const jsonDetalleObj = {
          cantidad: cantidadElement.value,
          item: selectedItemId[i],
          centrocosto: selectedCentroCostoId[i],
          proveedor: selectedProveedorId[i],
          preciorefunitario: precioUnitario.value,
          preciorefunitariototal: precioUnitarioTotal.value,
          detalles: detalles.innerHTML,
          aprobador: aprobadorUsuarioId?.id_usuario,
        };

        jsonObj.detalles.push(jsonDetalleObj);
      }

      const cantidadElement = document.getElementById(
        `cantidad_${divNuevoDetalleCounter}`,
      )?.childNodes[0] as HTMLFormElement;

      const item = document.getElementById(`os_item_${divNuevoDetalleCounter}`)
        ?.childNodes[1].childNodes[0].childNodes[0] as HTMLFormElement;

      const centroCosto = document.getElementById(
        `os_centro_costo_${divNuevoDetalleCounter}`,
      )?.childNodes[1].childNodes[0].childNodes[0] as HTMLFormElement;

      const proveedor = document.getElementById(
        `os_proveedor_${divNuevoDetalleCounter}`,
      )?.childNodes[1].childNodes[0].childNodes[0] as HTMLFormElement;

      const precioUnitario = document.getElementById(
        `os_precio_unitario_${divNuevoDetalleCounter}`,
      )?.childNodes[0] as HTMLFormElement;

      const precioUnitarioTotal = document.getElementById(
        `os_precio_unitario_total_${divNuevoDetalleCounter}`,
      )?.childNodes[0] as HTMLFormElement;

      const detalles = document.getElementById(
        `os_detalles_${divNuevoDetalleCounter}`,
      ) as HTMLFormElement;

      const aprobador = document.getElementById(
        `os_usuarios_aprueba_${divNuevoDetalleCounter}`,
      )?.childNodes[1].childNodes[0].childNodes[0] as HTMLFormElement;

      if (cantidadElement.value.startsWith("0")) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar una cantidad en la fila " + divNuevoDetalleCounter,
        );
      } else if (item.value == "") {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un producto/servicio en la fila " +
            divNuevoDetalleCounter,
        );
      } else if (centroCosto.value == "") {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un centro de costo en la fila " +
            divNuevoDetalleCounter,
        );
      } else if (proveedor.value == "") {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un proveedor en la fila " + divNuevoDetalleCounter,
        );
      } else if (
        isNaN(parseFloat(precioUnitario.value.replace(",", "."))) ||
        parseFloat(precioUnitario.value.replace(",", ".")) <= 0
      ) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar un precio unitario en la fila " +
            divNuevoDetalleCounter,
        );
      } else if (
        isNaN(parseFloat(precioUnitarioTotal.value.replace(",", "."))) ||
        parseFloat(precioUnitarioTotal.value.replace(",", ".")) <= 0
      ) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe existir un precio total en la fila " + divNuevoDetalleCounter,
        );
      } else if (detalles.innerHTML.length == 0) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debe ingresar detalles en la fila " + divNuevoDetalleCounter,
        );
      } else if (!VALIDATE_FORMAT_ALPHA_NUMERIC_AND_DOT(detalles.innerHTML)) {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Solo puedes ingresar en los detalles adicionales (glosas) letras, números, puntos, comas, guión o guión bajo, no se permiten espacios al final ni saltos de línea con enter.",
        );
      } else if (aprobador.value == "") {
        showMsg(
          toast,
          "warn",
          "Advertencia",
          "Debes ingresar el usuario que aprueba el detalle de la solicitud",
        );
      } else {
        setShowModalConfirm(true);
        setShowDialogUploadFile(true);
        setJsonDataSolicitud(jsonObj);
      }
    }
  };

  return (
    <div
      id="os-container"
      style={{
        display: tipoSolicitudes.length < 0 ? "none" : "flex",
      }}
    >
      <Toast ref={toast} />
      <Joyride
        callback={handleJoyrideCallback}
        continuous={true}
        getHelpers={getHelpers}
        run={isOnboardOn}
        scrollToFirstStep={true}
        showProgress={true}
        showSkipButton={true}
        steps={steps}
        locale={{
          skip: "Saltar",
          last: "Hecho",
          next: "Siguiente",
          back: "Regresar",
          close: "Cerrar",
          nextLabelWithProgress: "Siguiente (Paso {step} de {steps})",
          open: "Abrir el diálogo",
        }}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
      <div>
        <div
          id="os_card"
          ref={containerRef}
          className="os-card"
          style={{ overflowY: "auto" }}
        >
          <div style={{ justifyItems: "flex-start" }}>
            <h2
              style={{
                marginLeft: "20px",
                fontSize: "20px",
                fontWeight: "400",
                color: "#535350",
              }}
            >
              Creación de solicitudes de compra
            </h2>
            <p style={{ color: "#535350" }}>
              Complete todos los campos requeridos para crear una nueva
              solicitud de compra.
            </p>
          </div>
          <hr id="separator" style={{ width: "100%" }} />
          <div
            className="os-topbox"
            style={{
              width: "60%",
              marginBottom: selectedEstadoOpId === 3 ? "0px" : "80px",
              justifyContent: "center",
            }}
          >
            {showModalConfirm ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ModalConfirm
                  header="Confirmación"
                  text="¿Estás seguro de guardar la solicitud?"
                  show={true}
                  setShowModalConfirm={setShowModalConfirm}
                  setDocId={setDocId}
                  setNeedFetchingDoc={setNeedFetchingSoc}
                  data={jsonDataSolicitud}
                  jsonDestination="nvasolicitud"
                  data2=""
                  setGoHome={setGoHome}
                />
              </div>
            ) : null}

            {showModalFirma ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ModalSignature setShowModalSignature={setShowModalFirma} />
              </div>
            ) : null}

            {docId > 0 ? (
              <Dialog
                header="Subir archivos a la solicitud"
                visible={showDialogUploadFile}
                style={{ width: "55vw" }}
                modal
                contentStyle={{ height: "400px" }}
                onHide={() => {
                  (setShowDialogUploadFile(false), setGoHome(true));
                }}
              >
                <UploadFile
                  typeDoc="nvasolicitudes"
                  id={docId}
                  ano={ano}
                  mes={mes}
                  setDialogVisible={setShowDialogUploadFile}
                  setGoHome={setGoHome}
                />
              </Dialog>
            ) : null}

            <DropdownFilter
              id="os_tipo_solicitud"
              labelHead="Tipo de Solicitud"
              initialData={tipoSolicitudes}
              data={selectedTipoSolicitud}
              dataId={selectedTipoSolicitudId}
              handleUpdateItems={handleUpdateTipoSolFromChild}
              idRow="0"
            />

            <DropdownFilter
              id="os_mes_gasto"
              labelHead="Mes de Gasto"
              initialData={meses}
              data={selectedMesGasto}
              dataId={selectedMesGastoId}
              handleUpdateItems={handleUpdateMesGastoFromChild}
              idRow="0"
            />

            <div>
              <DropdownFilter
                id="os_estado_operacional"
                labelHead="Estados Operacionales"
                initialData={estadosOperacionales}
                data={selectedEstadoOp}
                dataId={selectedEstadoOpId}
                handleUpdateItems={handleUpdateEstadoOpFromChild}
                idRow="0"
              />

              {selectedEstadoOpId === 3 ? (
                <div style={{ marginTop: "20px" }}>
                  <InputTextarea
                    id="observaciones"
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                    rows={5}
                    cols={30}
                    autoResize
                    placeholder="Ingrese el motivo de la asignación directa..."
                    className="w-full"
                  />
                </div>
              ) : null}
            </div>
            <DropdownFilter
              id="os_tipo_moneda"
              labelHead="Tipo de Monedas"
              initialData={tiposMoneda}
              data={selectedTipoMoneda}
              dataId={selectedTipoMonedaId}
              handleUpdateItems={handleUpdateTipoMonedaFromChild}
              idRow="0"
            />
          </div>

          <hr id="separator" style={{ width: "100%" }} />

          {/*********************** BODY ******************************/}

          <RowDivDetalleSolicitud key={0} number={0} />

          <div>
            <div id="childrenDetalleContainer">{childrenDetalle}</div>
          </div>
          {/* Scroll anchor */}
          <div ref={scrollEndRef} style={{ height: "1px", clear: "both" }} />
        </div>

        {/*********************** FOOTER ******************************/}

        <div>
          {initData?.firma == null ? (
            <Button
              id="btn_create_firma"
              className="buttonformrow"
              style={{ margin: "10px", backgroundColor: "gray" }}
              onClick={() => setShowModalFirma(true)}
            >
              CREA TU FIRMA
            </Button>
          ) : null}

          {initData?.firma !== null ? (
            <Button
              id="btn_save_solicitud"
              className="buttonformrow"
              style={{ margin: "10px" }}
              onClick={() => {
                saveSolicitud();
              }}
            >
              GENERAR
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default NewSolicitudCompra;
